import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { isScullyRunning } from '@scullyio/ng-lib';

@Injectable()
export class MeetingService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  init(): void {
    if (!isScullyRunning()) {
      this.loadCss();
      this.loadScript();
    }
  }

  private loadCss(): void {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.type = 'text/css';
    link.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  private loadScript(): void {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    this.document.body.append(script);
  }
}
